import routes from './routes';
import { SetRoutes } from 'components';

const AssetsMainPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default AssetsMainPage;
